<template>
  <div>

    <!-- Jobs Area Starts -->
    <section class="jobs-area section-padding">
      <div class="container">
        <div class="row">
          <div id="square" class="col-lg-12 "  v-for="(v, i) in productList" :key="i">
            <div class="single-job mb-4 d-lg-flex justify-content-between fadeInUp animated ">
              <div class="job-text ">
                <h4>{{ v.name }}</h4>
                <div>{{ v.description }}</div>
                <!-- <ul class="mt-4">
                  <li class="mb-3">
                    <h5><i class="fa fa-map-marker"></i> new yourk, USA</h5>
                  </li>
                  <li class="mb-3">
                    <h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5>
                  </li>
                  <li>
                    <h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5>
                  </li>
                </ul> -->
              </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job1.png" alt="job">
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
    <!-- Jobs Area End -->
  </div>
</template>

<script>
export default {
  name: 'product',
  data () {
    return {

      productList: [{
        name: '设备试验管理',
        description: '设备试验管理包括试验数据管理、试验设备管理和试验综合分析3个方面，设备试验数据管理用来管理所有试验设备的试验信息；试验设备管理包括试验设备的基本信息管理、试验类型、试验周期和运行参数信息管理；试验综合分析通过不同的方法和角度来分析设备试验历史数据，获得有用的价值信息，为决策提供支持。'
      },

      {
        name: '运行管理',
        description: '运行调度管理模块是规范运行值班、安全作业等相关业务，完成对外部系统与各子系统的实时和统计数据的收集和整合，为运营调度、安全生产等提供数据基础和决策依据。'
      },
      {
        name: '安全可靠性管理',
        description: '安全可靠性管理由安全管理文件、安全活动管理、应急管理、安全人员教育与资质管理、特种设备管理、安全事故管理、环境保护和职业健康安全管理、可靠性管理和安全基础数据等几个部分组成。主要用于管理生产过程中与安全相关的事务性流程、相关记录与文件。'
      },
      {
        name: '故障树管理',
        description: '故障树是指根据设备类型建立的故障现象、故障原因、解决措施等的层次结构，是对检修、维护工作的总结，对设备维修工作具有一定的指导意义。'
      },
      {
        name: 'eKPI系统',
        description: '基于BI软件的企业绩效指标展示平台。'
      },
      {
        name: '工会费用报销系统',
        description: '费用报销管理的工会版本。'
      },
      {
        name: '检修项目管理',
        description: '检修项目管理要以标准化管理和项目管理为指导，实现标准检修项目的管理和执行检修项目的管理，对电站多设备集中检修的计划和执行进行有效的管理和监控。'
      },
      {
        name: '检修记录管理',
        description: '检修记录管理主要是进行实现设备检修记录信息的录入管理以及对应的检修记录信息录入管理，形成结构化数据并生成相关WORD版本的检修记录报告及数据分析等内容的管理和维护的业务需求。'
      },
      {
        name: '评标专家管理',
        description: '评标专家、专家评价记录、参加招标历史等的查询、创建、修改、审批等操作，维护与评标专家相关的各关联对象，维护与外部系统接口。'
      },
      {
        name: '供应商评价管理',
        description: '主要根据供应商的分类和相关的业务情况建立相应的评价标准并执行年度评价。'
      },
      {
        name: '合同管理',
        description: '合同的查询、创建、修改、审批、同步、状态流转等操作，维护与合同相关的各关联对象，维护与外部系统的接口。'
      },
      {
        name: '财务共享平台',
        description: '基于信息系统的应用设置实现共享业务事务数据、共享财务核算数据和共享财务核算人力资源，建立财务核算任务管理，可以灵活配置，任务分配和领取并为财务核算统计提供依据。'
      },
      {
        name: '财务报销管理',
        description: '费用报销模块实现了员工执行费用报销从申报到执行全过程管理，并引入企业相关定额规范控制过程，打通与商旅系统以及OCR接口。'
      },
      {
        name: '融资管理',
        description: '融资管理包括融资基础数据管理、融资项目管理、融资项目变更管理、计提与摊销管理、外部系统接口等。'
      },
      {
        name: '资金预算管理',
        description: '资金预算主要包括资金预算的申报与审批，各相关部门对自己下月需要的资金按照固定的申报模板进行填写申报，对申报好的资金预算各层领导对申报的资金进行审批。'
      },
      {
        name: '财务自动核算平台',
        description: '实现业财一体化，建立业务到财务的数据流转化，建立以下自动核算功能：物资库存核算、采购支付核算、费用报销核算、项目核算、固定资产核算、薪酬核算、电能销售核算、房产税、印花税计提、融资核算和通用制证等。'
      },
      {
        name: '费用定额管理',
        description: '主要包括费用预算标准定额和费用执行定额来实现费用定额的标准定义。费用预算标准定额为计划预算的申报提供依据和标准，费用执行定额为费用报销提供依据和标准。'
      },
      {
        name: '考勤管理',
        description: '通过对请休假管理、加班管理、年休假计划、日常考勤等功能的操作完成考勤的全过程管理。以及考勤基础数据的维护功能都是在该模块内完成。'
      },
      {
        name: '实物资产管理',
        description: '企业实物资产全流程管理，包括资产卡片、资产变更、资产移动、资产合并、资产拆分、资产报废、资产处置等。'
      },
      {
        name: '资产移动盘点管理',
        description: '移动终端固定资产清查系统主要实现ePMS系统无法或不便参与的实际业务操作，为物资管理实际操作人员提供便利服务，如数据采集、基础数据查询等，作为ePMS物资管理的一个插件，提高ePMS系统的应用价值，物资管理的实际操作带来便利，提高效率。'
      },
      {
        name: '运行移动巡检管理',
        description: '对一系列设备在同一个许可下进行维护检修，可将多个设备排成检修路线，按不同的路线来检查不同设备以获得最大效率。每个路线由路线中单个设备的分立的PM操作组成。在路线中可以为每个PM操作指定不同的事件及监测标准。'
      }
      ]

    }
  }
}
</script>

<style scoped>
/*base code*/

</style>




// WEBPACK FOOTER //
// WareProduct.vue?1cde6cdb